let state = {
  _js_has_load: [],
  _showWa: false, //默认WhatsApp注册入口控制
  _law_checked: false, //法律条款是否默认勾选，BR在用
  _ticket: null,
  _cell: null,
  _uuid: null,
  _product_change: false,
  _product: 2,
  _identity: "3", //1 司机 2 车头 3车主 4 IE driver
  _product_name: '', // 产品线名字
  _area: {},
  _city: {},
  _location: {
    lat: '',
    lng: ''
  },
  _role_page_skip: {
    2: false,
    1: false,
    3: false
  },
  _open_type: "", //城市信息的key，此处为特殊处理
  _city_open_type: "",
  _br_new_text: false, //巴西产品线页、身份页文案实验,
  _roleTrans: "", //俄罗斯角色转换标识，后续可能开放给其他global国家,
  _phone_focus: true, //手机区号点击是否自动吊起键盘
  _phone_focus_global: false, //gloabl 实验手机区号点击是否自动吊起键盘
  _login_btn_text: false, //global 引导文案是否命中实验
  _auto_submit: false, //基础信息页是否自动提交
  _br_type_product_text: true, //角色选择页、产品线选择页, 引导文案实验(巴西) (实验全量)
  _mx_type_product_text: false, // 角色选择页、产品线选择页, 引导文案实验(墨西哥)
  _help_icon: false, // help帮助入口
  _help_icon_url: "", //help跳转的链接
  _help_icon_icon_url: "", //help icon图片链接
  _ru_se_driver_switch_test: true, // 是否开启俄罗斯se司机入口
  _mx_id_no_ab_test: false, // 墨西哥id_no后置实验, 只在墨西哥城做
  _ru_fleet_driver_role_divison_test: true, // 俄罗斯注册页是否走新角色
  _landing_H5_1110: false, // 是否开启new landingPage实验(巴西)
  _landing_page_open_switch: true, // 是否进入新配置的首页(landing_page_open_switch全部放量)
  _mx_landingpage_h5_0302: false, // mx h5是否进入new landingpage
  _mx_landingpage_wa_0302: false, // mx WA是否进入new landingpage
  _page_stay_time: 0, // 页面停留时长
  _page_jump_time: 0, // 页面跳转时长
  _route_path: [], // 路由跳转数组
  _dialog_close: false, // 点击二级页面叉号弹窗
  _audit_page_omega: {}, // 证件页的埋点，要往详情页透传的
  _login_config: null, // 给passport setConfig的传参
};
export default state;
